"use strict";
/**
 * Created by rouven on 12.04.17.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_symbol_1 = __importDefault(require("@wikom/react-symbol"));
/**
 * Renders ReactNode wrapper button for ReactNode
 *
 * @param backLinkProps - Props containing a child node to be wrapped and className of wrapper back-link button
 * @returns ReactNode wrapped into a button with onClickHandler calling useHistory hook: go(-1)
 */
var BackLink = function (_a) {
    var _b = _a.children, children = _b === void 0 ? react_1["default"].createElement("span", null,
        react_1["default"].createElement(react_symbol_1["default"], { symbol: "arrow-circle-left" }),
        " zur\u00FCck") : _b, _c = _a.className, className = _c === void 0 ? 'btn btn-primary' : _c;
    var go = (0, react_router_dom_1.useHistory)().go;
    return (react_1["default"].createElement("button", { type: "button", className: className, onClick: function () { return go(-1); } }, children));
};
exports["default"] = BackLink;
